import { useEffect } from 'react';

/**
 * Redirects the user to an external URL on mount.
 * Used for routes that have moved to the marketing site.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}
